// ParseEasy AWS test environment (admin portal)
export const environment = {
  production: true,
  apiUrl: 'https://api-test.parseeasy.com/api/v1',
  wiseAuthUrl: 'https://auth.wisesolutions.app',
  // USER: Confirm WiseAuth admin client ID with your team and update if different
  wiseAuthClientId: 'parseeasy-admin-test',
  wiseAuthRedirectUri: 'https://admin-test.parseeasy.com/auth/callback',
  features: {
    enableAnalytics: false,
    enableDebugMode: true,
    enableMockData: false
  },
  admin: {
    requireAdminRole: true,
    allowedRoles: ['admin', 'super_admin', 'system_admin'],
    sessionTimeout: 3600000,
    autoRefreshInterval: 300000
  }
};
